import React, { Component } from 'react';
import '../css/imgStyles.css';

class CAFMSys extends Component {
    state = {
        points1: [
            {
                title: "Dash board",
                points: [
                    "Statistical graphs"
                ]
            },
            {
                title: "Contracts",
                points: [
                    "Registration of client",
                    "Registration of contract",
                    "Registration of all services and actual costs" 
                ]
            },
            {
                title: "Assets",
                points: [
                    "Registration of assets list",
                    "Records of assets maintenance history"

                ]
            },
            {
                title: "Maintenance",
                points: [
                    "Opening of maintenance ticket",
                    "Opening of job card",
                    "Update of job card",
                    "Close of job card",
                    "Registry of maintenance works for each asset",
                    "Registry of periodical maintenance schedule",
                    "Maintenance reports",
                    "Power consumption monitory",
                ]
            },
            {
                title: "Finance",
                points: [
                    "Registry of all services and costs",
                    "Invoicing",
                    "Payments",
                    "Client statement of account",
                ]
            },
            {
                title: "Client website members portal",
                points: [
                    "Dash board",
                    "Assets list",
                    "Preventive planned maintenance schedule",
                    "Periodical maintenance and calls registry per asset",
                    "Client statement",
                    "Invoices",
                    "Payments",
                    "Circulations and announcement communication",
                    "Water consumption records and graphs",
                    "Notifications",
                ]
            }
        ]
    }

    render() {
      return (
        <React.Fragment>
            <p id="title">CAFM System</p>

            <p>
                To deliver outstanding services to our clients and 
                in order to emphasize on the customer - client relation, 
                we have developed a professional, yet easy to use 
                “computer-aided facility management” software that allows 
                us to register all transactions done in the client facility 
                and particularly in each asset registered in the system. 
                The software also enables us to interact with the client 
                through a client’s “members portal”.
            </p>
            <p>
                Below is a list of the tasks delivered by the CAFM system:
            </p>

            <ol>
                {
                    this.state.points1.map(p => {
                        return (
                            <li className="liStyle">
                                {p.title}
                                <ul>
                                    {
                                        p.points.map(i => {
                                            return (
                                                <li>{i}</li>
                                            )
                                        })
                                    }
                                </ul>    
                            </li>
                        )
                    })
                }    
            </ol>   
        </React.Fragment>
      );
   }
}

export default CAFMSys;